import { Funnel } from '../types/funnel.types';

/**
 * Validation result interface
 */
export interface ValidationResult {
  valid: boolean;
  errors: string[];
}

/**
 * Validate funnel before saving/exporting
 * Checks:
 * - Funnel name is not empty or whitespace
 * - Funnel has at least one section
 */
export const validateFunnelForSave = (funnel: Funnel): ValidationResult => {
  const errors: string[] = [];

  // Check if funnel name is empty or just whitespace
  if (!funnel.name || funnel.name.trim() === '') {
    errors.push('Funnel name is required');
  }

  // Check if funnel has no sections (empty funnel)
  if (!funnel.sections || funnel.sections.length === 0) {
    errors.push('Funnel must have at least one section');
  }

  return {
    valid: errors.length === 0,
    errors,
  };
};

